/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Cancelredirect1Inputs */

const zh_subscription_cancelredirect1 = /** @type {(inputs: Subscription_Cancelredirect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在跳转取消订阅页面…`)
};

const en_subscription_cancelredirect1 = /** @type {(inputs: Subscription_Cancelredirect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting to cancel subscription...`)
};

const es_subscription_cancelredirect1 = /** @type {(inputs: Subscription_Cancelredirect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirigiendo a cancelar suscripción...`)
};

/**
* | output |
* | --- |
* | "Redirecting to cancel subscription..." |
*
* @param {Subscription_Cancelredirect1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_cancelredirect1 = /** @type {((inputs?: Subscription_Cancelredirect1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Cancelredirect1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_cancelredirect1(inputs)
	if (locale === "en") return en_subscription_cancelredirect1(inputs)
	return es_subscription_cancelredirect1(inputs)
});
export { subscription_cancelredirect1 as "subscription_cancelRedirect" }